import { render, staticRenderFns } from "./NoticeOfExemptionFromParentingEducationProgram.vue?vue&type=template&id=6b96848e"
import script from "./NoticeOfExemptionFromParentingEducationProgram.vue?vue&type=script&lang=ts"
export * from "./NoticeOfExemptionFromParentingEducationProgram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports